import { PropsWithChildren } from "react";

import { Modal, Button } from "@components/index";
import AlertImg from "@assets/images/alert-triangle.svg";

export const ConfirmModal = ({
  show,
  text1,
  text2,
  confirmButtonType = "button",
  confirmButtonTitle,
  cancelButtonTitle = "Cancel",
  disabledConfirmButton = false,
  onClickCancel,
  onClickConfirm,
  children,
}: {
  show: boolean;
  text1?: string;
  text2?: string;
  confirmButtonType?: "button" | "submit";
  confirmButtonTitle: string;
  cancelButtonTitle?: string;
  disabledConfirmButton?: boolean;
  onClickCancel: () => void;
  onClickConfirm: () => void;
} & PropsWithChildren) => (
  <Modal className="max-w-lg" show={show} onClose={onClickCancel}>
    <div className="flex flex-col items-center text-center">
      {children ? (
        <div className="w-full">{children}</div>
      ) : (
        <>
          <img
            src={AlertImg}
            alt="Alert"
            className="h-12 w-12 md:h-14 md:w-14"
          />
          {text1 && (
            <div className="pt-2 text-400 font-bold text-black-100 md:pt-4 md:text-500">
              {text1}
            </div>
          )}
          {text2 && (
            <div className="pt-1 text-100 text-black-54 md:text-300 md:font-light md:text-black-70">
              {text2}
            </div>
          )}
        </>
      )}
    </div>
    <div className="flex justify-between gap-x-2 pt-8 md:gap-x-8 md:pt-12">
      <Button
        title={cancelButtonTitle}
        className="w-full max-w-52"
        onClick={onClickCancel}
      />
      <Button
        type={confirmButtonType}
        variant="secondary"
        title={confirmButtonTitle}
        className="w-full max-w-52"
        disabled={!!disabledConfirmButton}
        onClick={onClickConfirm}
      />
    </div>
  </Modal>
);
